import React, { useState, useContext } from "react";
import Footer from "./Footer";
import Reviews from "./Reviews";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import products from "../products";
import Slider from "./Slider"

function Home() {
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);

  // State for modal
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openModal = (product) => setSelectedProduct(product);
  const closeModal = () => setSelectedProduct(null);

  const images = products.slice(0, 8).map(({ id, image, name, price }) => ({
    id,
    src: image,
    name,
    price,
  }));

  return (
    <div className="bg-grey">
      <Slider />
      <section className="bg-grey text-white py-12 mx-auto">
        <div className="max-w-[588px] mx-auto text-center">
          <h2 className="text-[32px] font-bold">Explore Our Collections
          </h2>
          <p className="text-gray-400 mt-2 font-[20px]">Curated favorites just for you! Find stylish decor pieces that brings personality and charm to your space.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 p-6">
          {images.map((image) => (
            <div key={image.id} className="w-full cursor-pointer" onClick={() => openModal(image)}>
              <img src={image.src} alt={image.name} className="w-full h-auto aspect-[2001/1601] object-contain" />
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <button className="px-[52px] py-[15px] border border-white bg-white text-black text-[16px] font-bold" onClick={() => navigate("/collection")}>
            VIEW MORE
          </button>
        </div>
      </section>

      <Reviews />
      <Footer />

      {/* Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-center w-full h-full" onClick={closeModal}>
          <div className="bg-white text-black p-6 rounded-lg w-[70vw] h-[70vh] relative flex flex-col shadow-lg" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="absolute top-4 right-4 text-2xl font-bold text-gray-600 hover:text-black" onClick={closeModal}>
              &times;
            </button>

            {/* Product Details */}
            <div className="flex flex-col md:flex-row h-full">
              {/* Image Section */}
              <div className="w-full md:w-1/2 flex justify-center items-center p-4">
                <img src={selectedProduct.src} alt={selectedProduct.name} className="w-full h-auto object-contain rounded-lg" />
              </div>

              {/* Details Section */}
              <div className="w-full md:w-1/2 flex flex-col justify-center p-6">
                <h2 className="text-3xl font-bold mb-4">{selectedProduct.name}</h2>
                <p className="text-lg text-gray-700 mb-4">Price: <span className="font-semibold">₦{selectedProduct.price.toLocaleString()}</span></p>

                {/* Add to Cart Button */}
                <button
                  className="mt-4 px-6 py-3 bg-orange text-white text-lg font-bold transition"
                  onClick={() => {
                    addToCart({
                      id: selectedProduct.id,
                      name: selectedProduct.name,
                      price: selectedProduct.price,
                      image: selectedProduct.src,
                    });
                    closeModal();
                  }}
                >
                  Add to Cart
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
